import { HRPortalSignUpService } from '@openeducation/oe-rn-services';
import type {
  CognitoAuthError,
  PurchaserId,
} from '@openeducation/oe-rn-shared-types';
import { useMutation } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';

interface HRPortalSignUpProps {
  email: string;
  purchaserId: PurchaserId;
}

export const useHRPortalSignUp = () => {
  const { environment } = useEnvironmentContext();

  const { isSuccess, error, isLoading, mutateAsync } = useMutation(
    ({ email, purchaserId }: HRPortalSignUpProps) =>
      HRPortalSignUpService.signUp(environment, email, purchaserId)
  );

  return {
    signUp: mutateAsync,
    isSignUpSuccess: isSuccess,
    isSignUpLoading: isLoading,
    signUpError: error as CognitoAuthError,
  };
};
